export default __webpack_public_path__ + "src/assets/menu.8ac2030ae4cd9af1a45b642d9cfd1073.svg";